module.exports = __webpack_public_path__ + "static/media/atago-win.0c293512.png";